import { base64ToText, getAttachmentValues, isAttachment } from "@qdabra/infopath-attachments";
import { compose, prop, when } from "ramda";
import { paramMode, paramValue } from "../constants/parameterNames";
import { typeOption } from '../constants/parameterTypes';
import { failure } from "../helpers/commandResult";
import { getParamValue } from "../helpers/parameter.accessors";

const description = 'Converts base64-encoded values to text values.';

const MODE_DECODE = 'decode';

const requiredParameters = {
    [paramValue]: {
        description: `The value to convert. Hint: use /${paramValue}-xpath to indicate the location of the value rather than the value itself.`,
    },
    [paramMode]: {
        description: `The type of conversion to perform. Currently only ${MODE_DECODE} is supported.`,
        type: typeOption,
        options: [
            { name: MODE_DECODE, value: MODE_DECODE },
        ],
    },
};

// Base64String -> Base64String
const attachmentInnerValue = compose(
    prop('base64'),
    getAttachmentValues,
);

// Base64String -> Base64String
const getActualBase64 = when(isAttachment, attachmentInnerValue);

const decode = (value) => {
    const actualBase64 = getActualBase64(value);

    return base64ToText(actualBase64);
};

const execute = ({ parameters }) => {
    const value = getParamValue(parameters, paramValue);
    const mode = getParamValue(parameters, paramMode);

    switch(mode) {
        case MODE_DECODE:
            return decode(value);
        default:
            return failure(`Invalid /${paramMode} value: ${mode}`);
    }
};


const ConvertBase64 = {
    description,
    requiredParameters,
    execute,
};


export default ConvertBase64;